import React from 'react';
import '../allcss/hero.css';
import wallImage from '../Asets/child_crayons.jpeg';
import Hero1 from '../Asets/Hero1.jpg';
import Hero2 from '../Asets/Hero2.jpg';
import Hero3 from '../Asets/Hero3.jpg';
import Hero4 from '../Asets/Hero4.jpg';

const AnimatedHeading = () => {
  // Split the text into lines to perfectly control the mobile structure
  const lines = [
    "Best Preschool in ",
    "Vadodara for ",
    "Joyful Learning"
  ];

  let globalIndex = 0;

  return (
    <h1 className="hero-animated-heading">
      {lines.map((line, lineIndex) => (
        <span key={lineIndex} className="hero-heading-line">
          {[...line].map((char) => {
            const currentIndex = globalIndex++;
            return (
              <span
                key={currentIndex}
                className="hero-drop-letter"
                style={{ animationDelay: `${currentIndex * 0.03}s` }}
              >
                {char === ' ' ? '\u00A0' : char}
              </span>
            );
          })}
          {/* Inject a line break after each line block, controlled by CSS */}
          {lineIndex < lines.length - 1 && <br className="hero-mobile-br" />}
        </span>
      ))}
    </h1>
  );
};

const Hero = () => {
  return (
    <div className="hero-wrapper">
      <div className="hero-container">
        {/* Floating Images */}
        <img
          src={Hero1}
          alt="Top Left"
          className="hero-float-img hero-circle-img hero-img-top-left"
        />
        <img
          src={Hero2}
          alt="Top Right"
          className="hero-float-img hero-circle-img hero-img-top-right"
        />
        <img
          src={Hero3}
          alt="Bottom Left"
          className="hero-float-img hero-circle-img hero-img-bottom-left"
        />
        <img
          src={Hero4}
          alt="Bottom Right"
          className="hero-float-img hero-circle-img hero-img-bottom-right"
        />

        {/* Content Section */}
        <div className="hero-text">
          <AnimatedHeading />
          
          <div className="hero-wavy-underline"></div>
          
          <h2 className="hero-subheading">
            Singapore-Inspired Preschool & Day Care
          </h2>

          <p className="hero-description">
            Welcome to <strong>RED School House</strong>, the <strong>Best Preschool in Vadodara</strong>, where children learn, play, and grow in a safe and nurturing environment. Our Singapore-inspired, play-based curriculum and experienced educators help build creativity, confidence, communication, and essential life skills through Playgroup, Nursery, KG, and Day Care programs.
          </p>

          <div className="hero-buttons">
            <a href="#get-started" className="hero-btn hero-btn-start">
              Enquire Now<span className="rocket-emoji">🚀</span>
            </a>
            <a href="#learn-more" className="hero-btn hero-btn-learn">  
              Book a School Tour
            </a>
          </div>
        </div>
      </div>

      <div className="hero-wall-image-container">
        <img src={wallImage} alt="Kids Drawing on Wall" className="hero-wall-image" />
      </div>
    </div>
  );
};

export default Hero;